import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  LinearProgress,
  makeStyles,
} from "@material-ui/core";
import { DoneOutline } from "@material-ui/icons";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  deleteSetting,
  resetSettingDeleteState,
  selectSettingDelete,
} from "./settingDeleteSlice";

interface DeleteDialogProps {
  open: boolean;
  id: number;
  handleClose: () => void;
}

const useStyles = makeStyles((theme) =>
  createStyles({
    icon: {
      verticalAlign: "middle",
      paddingRight: theme.spacing(1),
    },
  }),
);

export function DeleteDialog(props: DeleteDialogProps) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { status } = useSelector(selectSettingDelete);
  const { open, id, handleClose } = props;

  const handleSubmit = () => {
    dispatch(deleteSetting({ id }));
  };

  useEffect(() => {
    if (status === "succeeded") {
      handleClose();
      dispatch(resetSettingDeleteState());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, dispatch]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        <DoneOutline className={classes.icon} />
        CV連携設定：削除確認
      </DialogTitle>
      <DialogContent>
        <DialogContentText>このCV連携設定を削除しますか？</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>キャンセル</Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          disabled={status === "loading" || status === "succeeded"}
        >
          削除する
        </Button>
      </DialogActions>
      {status === "loading" ? <LinearProgress /> : undefined}
    </Dialog>
  );
}
